export const LAW_COLOR = "rgb(24, 79, 128)"
export const NON_LAW_COLOR = "#56b231"
export const FAIR_HOUSING_COLOR = "#079992"

export const COMPLETED_COLOR = "#56b231"
export const IN_PROGRESS_COLOR = "rgb(24, 79, 128)"
